import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute() {
  const token = localStorage.getItem("token");

  // No token → force login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
